{
  "page": {
    "title": "Alertas de snipe",
    "subtitle": "Receba mensagens diretas no Discord quando itens, mascotes ou WoW Token que você está monitorando aparecerem no leilão abaixo do seu preço alvo."
  },
  "discordRequired": {
    "title": "Discord necessário",
    "description": "Você precisa vincular sua conta Discord antes de configurar alertas de snipe. Os alertas são enviados como mensagens diretas do Discord.",
    "linkButton": "Ir para configurações para vincular o Discord"
  },
  "loading": "Carregando...",
  "notifications": {
    "title": "Notificações de snipe",
    "description": "Receba alertas quando itens ou mascotes monitorados forem encontrados abaixo do seu preço alvo."
  },
  "alertStyle": {
    "title": "Estilo de alerta",
    "subtitle": "Escolha como as notificações do Discord são exibidas.",
    "compact": "Compacto",
    "compactDescription": "Embeds somente de texto, sem miniaturas. Mais alertas por mensagem.",
    "detailed": "Detalhado",
    "detailedDescription": "Embeds ricos com miniaturas de itens. Um embed por item."
  },
  "cooldown": {
    "title": "Cooldown de alertas",
    "subtitle": "Quantos ciclos de atualização da casa de leilões (cerca de 1 hora cada) pular antes de alertar novamente sobre o mesmo leilão. 0 = alertar em toda atualização.",
    "cycles": "ciclo(s)",
    "save": "Salvar",
    "saving": "Salvando..."
  },
  "realms": {
    "title": "Reinos a monitorar",
    "subtitle": "Selecione quais reinos {{region}} monitorar para oportunidades de snipe.",
    "placeholder": "Selecione os reinos a monitorar",
    "removeRussian": "Remover todos os reinos russos",
    "saveButton": "Salvar reinos",
    "savingButton": "Salvando..."
  },
  "addEdit": {
    "addTitle": "Adicionar snipe {{type}}",
    "editTitle": "Editar snipe {{type}}",
    "typeLabel": "Tipo",
    "typeItem": "Item",
    "typePet": "Mascote",
    "typeToken": "Token",
    "typeIlvl": "ilvl",
    "itemNameLabel": "Nome do item",
    "petNameLabel": "Nome do mascote ou ID",
    "tokenLabel": "Token",
    "searchPlaceholder": "Pesquisar um item...",
    "petPlaceholder": "Digite o ID do mascote (ex. 3390) ou pesquise por nome...",
    "priceLabelMin": "1g",
    "priceLabelMax": "9.999.999g 99s",
    "targetPriceLabel": "Preço alvo",
    "pricePlaceholder": "ex. 500g ou 500g 50s",
    "ilvlMinLabel": "ilvl mín",
    "ilvlMaxLabel": "ilvl máx",
    "optional": "(opc)",
    "sockets": "Engastes",
    "secondaryStats": "Atributos Secundários",
    "secondaryStatsHint": "(opcional, selecione até 2)",
    "statCrit": "Crítico",
    "statHaste": "Aceleração",
    "statVersatility": "Versatilidade",
    "statMastery": "Maestria",
    "noItemsFound": "Nenhum item encontrado",
    "noPetsFound": "Nenhum mascote encontrado",
    "anyItem": "Qualquer item",
    "addButton": "Adicionar {{type}}",
    "updateButton": "Atualizar {{type}}",
    "addTokenButton": "Adicionar alerta de Token",
    "updateTokenButton": "Atualizar alerta de Token",
    "cancelEdit": "Cancelar edição",
    "remove": "Remover",
    "nounItem": "item",
    "nounPet": "mascote",
    "categoryLabel": "Categoria",
    "statSpeed": "Velocidade",
    "statLeech": "Sangria",
    "statAvoidance": "Evasão"
  },
  "importExport": {
    "importButton": "Importar JSON de {{label}}",
    "importingButton": "Importando...",
    "exportIlvlButton": "Exportar JSON de itens ilvl",
    "exportButton": "Exportar JSON de {{label}}",
    "clearAllButton": "Limpar todos {{label}} ({{count}})",
    "pasteHint": "Tip: Pressione Ctrl+V (ou Cmd+V no Mac) em qualquer lugar desta página para colar e importar um arquivo JSON diretamente.",
    "clearAllTitle": "Limpar tudo: {{label}}",
    "clearAllConfirmButton": "Limpar tudo"
  },
  "tabs": {
    "items": "Itens",
    "ilvlItems": "Itens ilvl",
    "pets": "Mascotes",
    "token": "WoW Token"
  },
  "table": {
    "filterPlaceholder": "Filtrar por nome do item ou ID...",
    "countAll": "{{count}} regra(s) ilvl",
    "countFiltered": "{{filtered}} de {{total}} regras ilvl",
    "countItems": "{{count}} {{noun}}",
    "countItemsFiltered": "{{filtered}} de {{total}} {{noun}}",
    "colItems": "Itens",
    "colIlvl": "ilvl",
    "colStats": "Estatísticas",
    "colBuyout": "Compra direta",
    "colActions": "Ações",
    "colTargetPrice": "Preço alvo",
    "editButton": "Editar",
    "duplicateButton": "Duplicar",
    "deleteButton": "Excluir",
    "emptyState": "{{hint}}",
    "emptyHintItems": "Pesquise um item acima ou importe um arquivo JSON para começar.",
    "emptyHintPets": "Digite um ID de mascote acima ou importe um arquivo JSON para começar.",
    "emptyHintToken": "Defina um preço-alvo acima para ser notificado quando a Ficha de WoW cair abaixo dele.",
    "emptyHintIlvl": "Defina limites de ilvl acima ou importe um arquivo JSON para começar.",
    "nounItems": "item(ns)",
    "nounPets": "mascote(s)",
    "nounToken": "alerta de token",
    "nounIlvl": "regra(s) de ilvl",
    "loadingName": "Carregando...",
    "colCategory": "Categoria",
    "percentLoaded": "{{percent}}% carregado",
    "editPrice": "Editar preço",
    "inlineEditHint": "Clique para editar — Enter salva, Esc cancela"
  },
  "personalConfig": {
    "title": "Configuração pessoal de filtros",
    "subtitle": "Ajuste os filtros abaixo para definir suas preferências padrão. Elas serão aplicadas automaticamente quando você usar as ferramentas de leilão.",
    "tip": "💡 Dica: configure seus filtros como desejar e clique em \"Salvar como padrões\" para torná-los suas configurações permanentes.",
    "livePreviewTitle": "Prévia ao vivo dos filtros",
    "livePreviewSubtitle": "Estes são os filtros reais da ferramenta de leilão. Defina seus padrões conforme necessário:",
    "saveButton": "Salvar filtros padrão",
    "resetToSavedButton": "🔄 Redefinir para meus padrões salvos",
    "resetToSystemButton": "⚙️ Redefinir para os padrões do sistema",
    "needHelp": "Precisa de ajuda com a configuração? Entre no nosso Discord",
    "dashboardSection": "Filtro de Oportunidades do Painel",
    "dashboardSectionSubtitle": "Define a faixa de preço de compra imediata para itens exibidos no widget de Principais Oportunidades do painel.",
    "dashboardBuyoutMin": "Compra Mín. (Ouro)",
    "dashboardBuyoutMax": "Compra Máx. (Ouro)",
    "dashboardBuyoutMaxHint": "Defina como 0 para sem máximo",
    "dashboardSaveButton": "Salvar Configuração do Painel",
    "itemMatchingSection": "Configurações de chave de item",
    "itemMatchingSectionSubtitle": "Controle como variantes de itens são correspondidas entre reinos ao calcular oportunidades.",
    "ignoreStatsBeforeExpansion": "Ignorar estatísticas secundárias antes desta expansão",
    "ignoreStatsBeforeExpansionHint": "Itens de expansões anteriores à selecionada serão tratados como idênticos independentemente do sufixo de estatística secundária. Útil para itens legados antigos onde as diferenças de estatísticas não afetam o valor de revenda.",
    "ignoreStatsNone": "Nenhum (desativado)",
    "itemMatchingSaveButton": "Salvar configurações de item"
  },
  "inventoryAnalysis": {
    "premiumRequired": "Você precisa de uma assinatura premium ativa para usar a ferramenta!",
    "subscriptionRequired": "Você precisa de uma assinatura ativa para usar a ferramenta!",
    "pasteCSVFirst": "Por favor, cole seus dados CSV de inventário primeiro.",
    "csvPasted": "CSV de inventário colado.",
    "pasteHint": "Tip: Pressione Ctrl+V (ou Cmd+V no Mac) em qualquer lugar desta página para colar seu CSV de inventário diretamente.",
    "noValidItems": "Nenhum item válido encontrado nos dados CSV. Verifique o formato.",
    "analysisComplete": "Análise concluída! Encontradas {{opportunities}} oportunidades de venda para {{items}} itens do inventário.",
    "analysisFailed": "Falha na análise do inventário. Por favor, tente novamente.",
    "title": "Análise de inventário",
    "description": "Cole seu export CSV de inventário do jogo abaixo. Analisaremos cada item em todos os reinos disponíveis para encontrar as melhores oportunidades de venda.",
    "addonInstall": "Instale o addon em",
    "addonInstallHere": "aqui",
    "csvFormatTitle": "Formato CSV esperado",
    "csvFormatNote": "Delimitado por ponto e vírgula. BonusIDs são separados por dois pontos (ex.",
    "csvModifiersNote": "). Modificadores usam",
    "csvModifiersFormat": "tipo=valor",
    "csvModifiersExample": "formato (ex.",
    "sellingRealmsTitle": "Reinos de venda para o inventário",
    "suggestedDropships": "Dropships sugeridos",
    "inventoryDataLabel": "Dados de inventário",
    "itemsDetected": "{{count}} item detectado",
    "itemsDetectedPlural": "{{count}} itens detectados",
    "uploadFile": "Enviar arquivo",
    "analyzeButton": "Analisar {{count}} itens",
    "analyzeInventoryButton": "Analisar inventário",
    "clearButton": "Limpar",
    "backToInput": "Voltar para a entrada de inventário",
    "noOpportunities": "Nenhuma oportunidade de venda encontrada para os itens do seu inventário.",
    "noOpportunitiesReason": "Isso pode acontecer se os itens não tiverem dados de mercado TSM ou não forem negociáveis.",
    "tryAgain": "Tentar novamente",
    "exportCSV": "Exportar para FlipQueue"
  },
  "realmConfig": {
    "setupGuideLink": "Clique aqui para o guia de configuração da ferramenta",
    "selectRegion": "Selecionar região atual",
    "updateBuyingRealms": "Atualizar reinos de compra para {{region}} ({{selected}} de {{total}})",
    "updateSellingRealms": "Atualizar reinos de venda para {{region}} ({{selected}} de {{max}})",
    "sellingRealmLimitTooltip": "Como assinante com uma assinatura {{type}} você pode selecionar apenas {{max}} reinos de venda.",
    "addAllToBuying": "Adicionar todos os reinos aos reinos de compra",
    "removeAllFromBuying": "Remover todos os reinos dos reinos de compra",
    "removeRussianFromBuying": "Remover todos os reinos russos dos reinos de compra",
    "addAllToSelling": "Adicionar todos os reinos aos reinos de venda",
    "removeAllFromSelling": "Remover todos os reinos dos reinos de venda",
    "removeRussianFromSelling": "Remover todos os reinos russos dos reinos de venda",
    "wowAccountsTitle": "Contas WoW",
    "addAccount": "Adicionar conta",
    "accountNamePlaceholder": "Nome da conta (ex. WoW2)",
    "accountNameRequired": "O nome da conta é obrigatório",
    "addAccountFailed": "Falha ao adicionar conta",
    "deleteAccountDefault": "Não é possível excluir a conta padrão",
    "deleteAccountConfirm": "Tem certeza? Esta conta será removida de todas as atribuições de reinos.",
    "deleteAccountFailed": "Falha ao excluir conta",
    "updateAccountFailed": "Falha ao atualizar nome da conta",
    "assignRealmsLabel": "Atribuir reinos a contas (um reino pode estar em várias contas):",
    "selectAll": "Selecionar tudo",
    "deselectAll": "Desmarcar tudo",
    "noRealmsSelected": "Nenhum reino selecionado",
    "addMoreAccounts": "Adicione mais contas para atribuir reinos a diferentes contas WoW.",
    "saveButton": "Salvar todos os dados",
    "missingAccountsError": "Por favor, atribua pelo menos uma conta a cada reino. Faltando: {{realms}}",
    "discordQuestion": "Ainda tem alguma dúvida? Entre no nosso Discord",
    "navigateToFlippingTool": "Flipping Tool",
    "navigateToDropshipTool": "Dropship Tool",
    "navigateToHousingTool": "Housing Tool",
    "navigateToTSMListGenerator": "Gerador de listas TSM",
    "saveButtonDirty": "Salvar alterações •",
    "saveSettingsFailed": "Não foi possível salvar as configurações",
    "unsavedTitle": "Alterações não salvas",
    "unsavedLeaveMessage": "Você tem configurações de reinos não salvas. Se sair desta página, suas alterações serão perdidas.",
    "unsavedLeaveConfirm": "Sair sem salvar",
    "unsavedStay": "Permanecer na página",
    "saveBeforeNavTitle": "Salvar suas alterações?",
    "saveBeforeNavMessage": "Sua seleção de reinos tem alterações não salvas. Salve-as para que a ferramenta use suas novas configurações.",
    "saveAndContinue": "Salvar e continuar",
    "deleteAccountTitle": "Excluir conta do WoW",
    "deleteAccountMessage": "Excluir a conta \"{{name}}\"? Ela será removida de todas as atribuições de reinos.",
    "deleteAccountConfirmButton": "Excluir",
    "renameAccountAria": "Renomear a conta {{name}}",
    "deleteAccountAria": "Excluir a conta {{name}}",
    "confirmRenameAria": "Salvar o nome da conta",
    "cancelRenameAria": "Cancelar renomeação",
    "confirmAddAria": "Adicionar conta",
    "cancelAddAria": "Cancelar adição de conta"
  },
  "tsmProfile": {
    "title": "Guia de configuração de perfil TSM",
    "realmPriceAnalysis": "Análise de preços do reino",
    "minimumPriceOperation": "Operação de preço mínimo",
    "maximumPriceOperation": "Operação de preço máximo",
    "normalPriceOperation": "Operação de preço normal",
    "copyButton": "Copiar",
    "copiedSuccess": "Operação de preço TSM {{operation}} copiada para a área de transferência!",
    "copyFailed": "Falha ao copiar para a área de transferência"
  },
  "tsmListGenerator": {
    "subscriptionRequired": "Você precisa de uma assinatura ativa para usar a ferramenta!",
    "watchVideoGuide": "Assistir ao guia em vídeo",
    "copyTSMString": "Copiar string TSM",
    "copyTSMFailed": "Falha ao copiar a string TSM para a área de transferência",
    "videoGuideTitle": "Guia em vídeo do gerador de listas TSM",
    "emptyTitle": "Nenhum dado de leilão encontrado",
    "emptyDescription": "Nenhum dado de leilão corresponde aos seus reinos configurados. Verifique sua configuração de reinos ou tente novamente após a próxima atualização da casa de leilões.",
    "emptyConfigureButton": "Configurar reinos",
    "emptyRetryButton": "Tentar novamente"
  },
  "realmStats": {
    "subscriptionRequired": "Você precisa de uma assinatura ativa para usar a ferramenta!",
    "overallStatistics": "Estatísticas gerais",
    "realmPriceAnalysis": "Análise de preços do reino",
    "watchVideoGuide": "Assistir guia em vídeo",
    "noData": "Nenhum dado de reino disponível",
    "legend": "Legenda",
    "legendCheap": "Bastante barato (<{{ratio}})",
    "legendNormal": "Em torno do normal ({{min}}-{{max}})",
    "legendExpensive": "Significativamente caro (>{{ratio}})",
    "tooltipCheap": "Isso significa que os itens em geral estão mais próximos da média de venda regional em preço. É bastante barato comprar aqui, mas não tão bom para vender.",
    "tooltipNormal": "Isso significa que os itens estão mistos em relação à média de venda regional. Pode ser bom para comprar e vender.",
    "tooltipExpensive": "Isso significa que os itens em geral estão bem acima da média de venda regional em preço. É bastante caro comprar aqui e pode ser bom para vender.",
    "colRealmName": "Nome do reino",
    "colPopulation": "População",
    "colAuctions": "Leilões",
    "colPriceRatio": "Razão de preço",
    "colCheaper": "Mais barato",
    "colExpensive": "Mais caro",
    "colPercentCheaper": "% Mais barato",
    "colPercentExpensive": "% Mais caro",
    "colPercentEqual": "% Igual",
    "totalRealms": "Total de reinos",
    "totalAuctions": "Total de leilões",
    "avgPriceRatio": "Razão de preço média",
    "cheaperThanRegion": "Mais barato que a região",
    "totalAuctionsHistory": "Histórico de leilões totais",
    "avgPriceRatioHistory": "Histórico de razão de preço média",
    "percentCheaperHistory": "Histórico % mais barato",
    "auctionsHistory": "{{realm}} - Histórico de leilões",
    "priceRatioHistory": "{{realm}} - Histórico de razão de preço",
    "cheaperCountHistory": "{{realm}} - Histórico de contagem mais barata",
    "expensiveCountHistory": "{{realm}} - Histórico de contagem mais cara",
    "percentCheaperRealm": "{{realm}} - Histórico % mais barato",
    "percentExpensiveRealm": "{{realm}} - Histórico % mais caro",
    "percentEqualRealm": "{{realm}} - Histórico % igual",
    "videoTitle": "Guia de vídeo da ferramenta de estatísticas de reino"
  },
  "tsmDataTable": {
    "colItemName": "Nome do item",
    "colCategory": "Categoria",
    "colExpansion": "Expansão",
    "colSellRate": "Taxa de venda",
    "colSaleAvg": "Média de venda",
    "colRegionMarketValue": "Valor de mercado regional",
    "colRegionHistorical": "Histórico regional",
    "clickToCopy": "Clique para copiar: {{name}}",
    "tooltipSaleAvg": "Preço médio pelo qual um item foi vendido nos últimos 60 dias",
    "tooltipMarketValue": "Preço médio pelo qual um item foi publicado nos últimos 14 dias em todos os reinos da sua região",
    "tooltipHistorical": "Preço médio pelo qual um item foi publicado nos últimos 60 dias em todos os reinos da sua região"
  },
  "import": {
    "confirmTitle": "Confirmar importação",
    "confirmMessage": "Importar {{count}} entradas para a lista de {{tab}}?",
    "confirmMessageCategory": "Importar {{count}} entradas para a lista de {{tab}} (categoria: {{category}})?",
    "confirmButton": "Importar"
  }
}
